module.exports = __webpack_public_path__ + "static/media/crop-file-select.ba72fd73.svg";